export default __webpack_public_path__ + "static/media/15.ea869e29.jpg";